import { createSlice } from '@reduxjs/toolkit';
export const applicationDrillHeatMap = createSlice({
  name: 'applicationDrillHeatMap',
  initialState: {
    dataSet: {
      series: [{
        data: []
      }]
    },
    applicationHeatMapData: [],
    clickEvent: false,
    envClickEvent: false
  },
  reducers: {
    pushAccountWiseHeatMap: (state, action) => {
      state.applicationHeatMapData = action.payload;
      let heatMapData = state.applicationHeatMapData;
      let test = heatMapData.slice();
      test.sort((a, b) => b.originRiskScore - a.originRiskScore);
      let testMap = test.filter(item => item.originRiskScore !== 0);
      let heatMapSeriesName = testMap.map(item => item.envName);
      let heatMapSeriesData = testMap.map(item => item.originRiskScore);
      let heatMapSeriesType = testMap.map(item => item.appType);
      const updatedData = heatMapSeriesName.map((e, i) => {
        return {
          x: [heatMapSeriesType[i], e],
          y: heatMapSeriesData[i]
        };
      });
      state.dataSet.series[0].data = updatedData;
    },
    pushSelectedAccount: (state, action) => {
      state.selectedAccount = action.payload;
    },
    pushClickEvent: (state, action) => {
      state.clickEvent = action.payload;
    },
    pushEnvClickEvent: (state, action) => {
      state.envClickEvent = action.payload;
    }
  }
});
export const {
  pushAccountWiseHeatMap,
  pushSelectedAccount,
  pushClickEvent,
  pushEnvClickEvent
} = applicationDrillHeatMap.actions;
export default applicationDrillHeatMap.reducer;